import { Component, OnInit, Input, Output, AfterViewInit, ChangeDetectorRef, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { CalculationService, HTTPService, DataService, HelperService, FormatService } from 'app/services';

import { itemCreateLabel, itemTypeIcons, itemTypeLabel, itemTypePlaceholder } from 'app/constants/itemType.constants';
import { currency } from 'app/constants/currency.constants';
import { find, findIndex, sortBy } from 'lodash';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { DialogService } from 'primeng/dynamicdialog';
import { messages } from 'app/constants';

@Component({
  selector: 'app-canned-service-item',
  templateUrl: './canned-service-item.component.html',
  styleUrls: ['./canned-service-item.component.scss'],
})
export class ServiceItemComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() index: number;
  @Input() isLast: boolean = false;
  @Input() isSubItem: boolean = false;
  @Input() serviceItem: any = {};
  @Input() errors: any = {};
  @Input() isEditMode: boolean = false;
  @Input() isOtherTaxable: boolean = true;
  @Input() isSubletTaxable: boolean = false;
  @Input() serviceItemCount: number = 0;
  @Input() qtqAddOn: boolean = false;
  @Input() selectAllItems: boolean = false;
  @Input() isQTQAddOnEnable: boolean = false;
  @Input('itemData')
  set setItemData(itemData: any) {
    setTimeout(() => {
      if (itemData && !this.isDefaultItemSelectionDone) {
        this.isDefaultItemSelectionDone = true;
        this.handleSelect('title', itemData, false);
      }
    }, 100);
  }
  @Input() partsLookupDropDownList: any[] = [];
  @Input() isLoading: boolean = false;
  @Input() companyLocalization: boolean = false;
  @Input() currentLang: string = 'en';
  @Input() isTireStorage2Enabled: boolean = false;
  @Input() serviceItems: any = [];
  @Input() serviceInspection: any = {};


  @Output() itemDelete = new EventEmitter();
  @Output() calculateTotal = new EventEmitter();
  @Output() addServiceItem = new EventEmitter();
  @Output() calculateTotalQtqAddon = new EventEmitter();
  @Output() fieldChange = new EventEmitter()
  @Output() tireStorageInspection = new EventEmitter()

  isDefaultItemSelectionDone: boolean = false;
  title: string = '';
  type: any = {};
  taxable: any = {};
  itemResults: any = [];
  priceSuggestions: any = [];
  itemTypeIcons = { ...itemTypeIcons };
  itemTypeLabel = { ...itemTypeLabel };
  itemCreateLabel = { ...itemCreateLabel };
  itemTypePlaceholder = { ...itemTypePlaceholder };
  itemTypeOptions: any[] = [
    { highlightField: 'part', value: 'part', label: 'Part' },
    { highlightField: 'labor', value: 'labor', label: 'Labor' },
    { highlightField: 'tire', value: 'tire', label: 'Tire' },
    { highlightField: 'fees', value: 'hazmatFee', label: 'Fees' },
    { highlightField: 'other', value: 'other', label: 'Other' },
  ];

  taxableOptions: any[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
  itemTypeSuggestions: any[] = [];
  itemSuggestions: any[] = [];
  focus: any = {};
  isSearching: boolean = false;
  usd: string = currency.USD;
  isNewServiceAdded = false;
  isSeaching: boolean = false;
  defaultEstimateHour: number = 0;
  itemTypes: any[] = [];
  flatRateItem = { highlightField: 'flat rate', value: 'bundle', label: 'Flat rate' };

  constructor(
    private cdr: ChangeDetectorRef,
    private calculationService: CalculationService,
    private httpService: HTTPService,
    private helperService: HelperService,
    private formatService: FormatService,
    private dataService: DataService,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    this.setFlaggedItems();
    this.defaultEstimateHour = this.serviceItem.count;
    if(this.isTireStorage2Enabled) this.itemTypeOptions.splice(3, 0, { highlightField: 'tireStorage', value: 'tireStorage', label: 'Tire Storage' })
    this.itemTypeSuggestions = [...this.itemTypeOptions];
    this.itemTypes = this.itemTypeOptions.map(({ value }) => value);

    if (this.serviceItem.type) {
      this.isNewServiceAdded = true;
    }
    this.dataService.getqtqAddonEvent().subscribe((res) => {
      this.qtqAddOn = res;
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.serviceItem && changes.serviceItem.currentValue) {
      this.serviceItem = changes.serviceItem.currentValue;
      // Adding a fix for ALP-19128 issue # 2
      if(this.currentLang === 'fr') {
        this.title = this.serviceItem?.titleFR || this.serviceItem?.title;
      } else {
        this.title = this.serviceItem?.title || this.serviceItem?.titleFR;
      }
    }
  }

  handleFieldChange(){
    this.fieldChange.emit()
  }

  setFlaggedItems() {
    if (this.dataService.isFlatRateEnabled && !find(this.itemTypeOptions, { value: this.flatRateItem })) {
      this.itemTypeOptions.splice(findIndex(this.itemTypeOptions, { value: 'tire' }) + 1, 0, this.flatRateItem);
    }

    if (this.dataService.isSubletTrackingEnabled) {
      this.itemTypeOptions.splice(findIndex(this.itemTypeOptions, { value: 'hazmatFee' }) + 1, 0, { highlightField: 'sublet', value: 'sublet', label: 'Sublet' });
    }

    if (this.dataService.isQuickServiceEnabled) {
      this.itemTypeOptions.splice(findIndex(this.itemTypeOptions, { value: 'part' }) + 1, 0, { highlightField: 'Parts- Lookup', value: 'partLookUp', label: 'Parts- Lookup' });
    }
  }

  handleFocus(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';
  }

  handleBlur(type: string) {
    this.focus[type] = false;

    if (this.serviceItem.type === 'labor' && this.defaultEstimateHour !== this.serviceItem.count) {
      this.handleEstimatedCostUpdate();
    }

    if (type === 'title' && this.serviceItem.type !== 'other' && this.serviceItem.type !== 'sublet' && this.serviceItem.type !== 'partLookUp' && this.serviceItem.itemId) {
      this.serviceItem.title = this.title;
    }

    if (this.serviceItem.type === 'tireStorage' && this.isTireStorage2Enabled) {
      if (this.serviceItem.count > 6) {
        this.helperService.showToaster('error', messages.tireStorageCountMessage);
        // this.setTireStorageInfoTooltip();
        setTimeout(() => {
          this.serviceItem.count = '6';
          this.handleCalculatePrice();
        }, 500);
      }
    }
  }

  pushToList() {
    this.serviceItem.checked = !this.serviceItem.checked;
    this.calculateTotalQtqAddon.emit(this.serviceItem);
  }

  handleEstimatedCostUpdate() {
    let estimateHours = this.serviceItem.costEstimatedHours;

    if (estimateHours === 0) {
      estimateHours = this.serviceItem.count;
    }
    if (this.defaultEstimateHour > 0) {
      this.serviceItem.costEstimatedHours = (this.serviceItem.count / this.defaultEstimateHour) * estimateHours;
      this.serviceItem.cost = (this.serviceItem.count / this.defaultEstimateHour) * this.serviceItem.cost;
      this.defaultEstimateHour = this.serviceItem.count;
    }
  }

  async handleSelect(type: string, data: any, isLineItemNeeded: boolean = true) {
    const serviceItems = this.serviceItems.filter(element => element.itemId);
    if (findIndex(serviceItems, {itemId: this.serviceItem.itemId}) === -1 && this.isTireStorage2Enabled && data?.type === 'tireStorageTemplate' && (findIndex(serviceItems, {type: 'tireStorage'}) !== -1 || this.serviceInspection?.inspectionId)) {
      if(this.serviceInspection?.inspectionId) this.helperService.showToaster('error', 'An inspection is already added to this service. You can not add another tire storage with an inspection.');
      else this.helperService.showToaster('error', 'You can only store one set of tires per service. A tire in item is already added to service.');  
      return;
    }
    
    this.title = data.title;
    delete this.serviceItem.itemId;
    if (data.type === 'partLookUp' && !data._id) {
      data._id = await this.httpService.getObjectId();
    }
    if (type === 'title') {
      this.serviceItem.type = data.type === 'tireStorageTemplate' ? 'tireStorage' : data.type;
      this.serviceItem.title = data.title;
      this.serviceItem.titleFR = data.titleFR;
      this.serviceItem.itemId = data?._id;
      this.serviceItem.partTypeId = data?.partTerminologyID || '';
      this.serviceItem.price = this.serviceItem.type === 'labor' ? data.billRate : data.price;
      this.serviceItem.cost = data.cost;

      if (['part', 'tire'].includes(data.type)) {
        if (data?.shopDetails) {
          const obj = find(data.shopDetails, { shopId: this.dataService.currentShopId });
          if (obj) {
            this.serviceItem.price = obj.price;
            this.serviceItem.pricing = data.pricing ? data.pricing : obj.pricing;
          }
        }
      }

      this.serviceItem.commissionable = data.commissionable;
      this.serviceItem.description = data.description;
      this.serviceItem.descriptionFR = data.descriptionFR;
      this.serviceItem.displayDescOnOrder = data.displayDescOnOrder;
      this.serviceItem.displayHoursOnOrder = data.displayHoursOnOrder;
      this.serviceItem.supplier = data.supplier;
      this.serviceItem.costEstimatedHours = data.costEstimatedHours;
      this.serviceItem.isTaxable = data.isTaxable;
      this.serviceItem.code = data.code;
      this.serviceItem.stocked = data.stocked;
      this.serviceItem.category = data.category;
      this.serviceItem.salesCode = data.salesCode;
      this.serviceItem.model = data.model;
      this.serviceItem.subItems = data.subItems;
      this.serviceItem.size = data.size;
      this.serviceItem.seasonality = data.seasonality;
      this.serviceItem.status = data.status;
      this.serviceItem.costEstimatedHours = data.costEstimatedHours;
      this.serviceItem.count = this.serviceItem.type === 'labor' ? data.billableHours : data.count;
      this.serviceItem.qboId = data.qboId;
      this.serviceItem.locationQboItemRefId = data.locationQboItemRefId || {};
      this.serviceItem.qboItemRefId = data.qboItemRefId || '';
      this.serviceItem.hasCore = data.hasCore;
      this.serviceItem.coreCost = data.coreCost;
      this.serviceItem.totalCoreCost = data.totalCoreCost || data.coreCost;
      if (data.locations?.length && this.dataService.warehouse && this.dataService.warehouse.warehouseId) {
        const selectedLocation = data.locations.find((location: any) => location?.warehouseId === this.dataService.warehouse.warehouseId);
        if(selectedLocation) {
          this.serviceItem.locations = [selectedLocation];
        } else {
          //In case of single location tennant warehouse does not exists in that case location must be assigned as a part of fix - ALP-19136
          this.serviceItem.locations = data.locations[0];
        }
        
      } else {
        //In case of single location tennant warehouse does not exists in that case location must be assigned as a part of fix - ALP-19136
        if (data.locations?.length === 1) {
          this.serviceItem.locations = data.locations[0];
        }
      }

      if (this.serviceItem.type === 'bundle') {
        this.serviceItem.price = data.flatRate;
        this.serviceItem.flatRate = data.flatRate;
        this.serviceItem.subTotal = data.flatRate;
        this.serviceItem.netSubTotal = data.flatRate;

        if (this.serviceItem.subItems && this.serviceItem.subItems.length) {
          this.serviceItem.subItems.forEach((subItem: any) => {
            subItem.subTotal = subItem.flatRateAmount;
            subItem.netSubTotal = subItem.flatRateAmount;
          });
        }
      } else {
        this.serviceItem.subTotal = this.calculationService.roundOff(this.serviceItem.price * this.serviceItem.count);
        this.serviceItem.netSubTotal = this.serviceItem.subTotal;
      }

      this.focus.count = true;

      if (this.serviceItem.type === 'labor') {
        this.defaultEstimateHour = this.serviceItem.count;
      }

      if (this.serviceItem.type === 'hazmatFee') {
        this.serviceItem.isPassThroughTax = data.isPassThroughTax ? data.isPassThroughTax : false;
      }

      if (this.serviceItem.type === 'tire') {
        if (data.brandId) {
          this.serviceItem.brand = {
            brandId: data.brandId,
            name: data.brand,
          };

          if (data.category?.categoryId) {
            this.serviceItem.category = data.category;
          }
        } else if (data.category?.categoryId) {
          this.serviceItem.brand = {
            brandId: data.category.categoryId,
            name: data.category.name,
          };
        }
      }

      if (this.dataService.isPartWarrantiesEnabled && ['part', 'tire'].includes(data?.type)) {
        this.serviceItem.isWarrantyEligible = data?.isWarrantyEligible || false;
        this.serviceItem.warranty = {
          warrantySettingId: data?.warranty?.warrantySettingId,
          title: data?.warranty?.title,
        };
      }

      if (data.type === 'tireStorageTemplate' && this.isTireStorage2Enabled) {
        this.serviceItem.title = data.title;
        this.serviceItem.titleFR = data.titleFR;
  
        this.serviceItem.price = data.price;
        this.serviceItem.cost = data.cost;
        this.serviceItem.count = data.count;
        this.serviceItem.originalCount = data.count;
        this.serviceItem.originalCost = data.cost;
        this.serviceItem.originalPrice = data.price;
        this.serviceItem.commissionable = data.commissionable;
        this.serviceItem.displayDescOnOrder = data.displayDescOnOrder;
        this.serviceItem.displayHoursOnOrder = data.displayHoursOnOrder;
        this.serviceItem.itemSource = data.itemSource || '';
        this.serviceItem.type = 'tireStorage';
        (this.serviceItem.tireStorageStatus = ''), (this.serviceItem.tireStorageTemplateId = data._id);
        this.serviceItem.isTaxable = data.isTaxable;
        this.serviceItem.status = data.status;
        this.serviceItem.salesCode = data.salesCode || {};
        this.serviceItem.category = data.category;
        this.serviceItem.pricingType = data.pricingType;
        this.serviceItem.associatedInspection = data.associatedInspection;
        this.serviceItem.internalNotes = data.internalNotes;
  
        if (data.pricingType === 'flatFee') {
          this.serviceItem.mockFlatPrice = data.price;
          this.serviceItem.mockFlatCost = data.cost;
          this.serviceItem.price = data.price / data.count;
          this.serviceItem.cost = data.cost / data.count;
        }
  
        // this.tireStorageCount = this.serviceItem.count;
        if (this.dataService.isSalesCodeEnabled) {
          //adding the tire storage for the backward compaitbility data
          // if(!Object.keys(this.serviceItem?.salesCode)?.length) {
          //   if(this.tireStorageV2Category?.salesCode && this.tireStorageV2Category?.salesCode?.salesCodeId) {
          //     this.serviceItem.salesCode = this.tireStorageV2Category?.salesCode;
          //   }
          // }
          this.serviceItem.tags = this.helperService.updateClassficationServiceItemTag(this.serviceItem.tags, this.serviceItem);
        }

        if(data.associatedInspection && data.associatedInspection.inspectionId){
          this.httpService.searchInspection('').then(
            (inspections: any) => {
              if (inspections && inspections.records) {
                const inspection = inspections.records.find(element => element.isTireStorageInspection)
                if(inspection?._id) this.tireStorageInspection.emit(inspection)
              }
          })
        }
        
      }

      if (data?.partSpecification) {
        this.serviceItem.partSpecification = this.helperService.deepCopy(data?.partSpecification);
      }

      this.handleCalculatePrice();
    }

    if (isLineItemNeeded) {
      this.handleServiceItemAdd();
    }
  }

  handleChange(type: string, value: any) {
    this.serviceItem[type] = value;

    if (type === 'type') {
      this.focus.title = true;

      if (this.serviceItem.type === 'other') {
        this.serviceItem.status = true;
        this.serviceItem.isTaxable = this.isOtherTaxable;
      }

      if (this.serviceItem.type === 'sublet') {
        this.serviceItem.status = true;
        this.serviceItem.isTaxable = this.isSubletTaxable;
      }

      if (this.serviceItem.type === 'partLookUp') {
        this.serviceItem.status = true;
        this.itemSuggestions = this.partsLookupDropDownList;
      }

      if (this.serviceItem.itemId) {
        this.resetFields();
      }
    }else if (type === 'count') {
      if (this.serviceItem.type === 'tireStorage' && this.isTireStorage2Enabled) {
        if (Number(value) <= 6) {
          this.serviceItem.count = value;
          // this.tireStorageCount = value;
          this.setPriceCostTS();
        }
      }
    }

    if (this.serviceItem.type !== 'tireStorage') this.handleCalculatePrice();
    this.handleServiceItemAdd();
  }

  setPriceCostTS() {
    if (this.serviceItem.pricingType && this.serviceItem.pricingType === 'flatFee' && Number(this.serviceItem.count)) {
      this.serviceItem.mockFlatPrice = this.serviceItem.originalPrice;
      this.serviceItem.mockFlatCost = this.serviceItem.originalCost;
      this.serviceItem.price = this.serviceItem.originalPrice / Number(this.serviceItem.count);
      this.serviceItem.cost = this.serviceItem.originalCost / Number(this.serviceItem.count);
    } else {
      if (this.serviceItem.pricingType === 'perTire') this.handleCalculatePrice();
    }
  }

  highlighedItemType(text: string, query: string) {
    if (text && query) {
      let str = text.replace(/\s/g, '&nbsp;');

      const regex = new RegExp(`(${query.replace(/\s/g, '&nbsp;')})`, 'ig');
      str = str.replace(regex, `<span class="font-600"><b>$1</b></span>`);

      return str;
    }

    return text;
  }

  handleClear(item) {
    if (item.type === 'partLookUp') {
      this.itemSuggestions = this.partsLookupDropDownList;
    }
  }

  handleClearService() {
    this.itemResults = [];
  }

  resetFields() {
    this.serviceItem = {};

    if (this.itemTypes.includes(this.serviceItem.type)) {
      this.handleCalculatePrice();
    } else if (this.serviceItem.type === 'other' || this.serviceItem.type === 'sublet') {
      if (!this.serviceItem.count) {
        this.serviceItem.count = 1;
        this.handleCalculatePrice();
      }
    }
  }

  handleCalculatePrice() {
    if (this.serviceItem.type !== 'bundle') {
      const price = this.calculationService.roundOff(this.serviceItem.price);
      const count = this.calculationService.roundOff(this.serviceItem.count);

      this.serviceItem.subTotal = price * count;
    }

    this.calculateTotal.emit(true);
  }

  handleDelete() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Delete ${this.title}`,
        message: `Are you sure you want to delete this ${this.serviceItem.type}?`,
        button: {
          success: { title: 'Delete', backgroundColor: '#d47877' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.itemDelete.emit(this.index);
        this.handleCalculatePrice();
      }
      onClose.unsubscribe();
    });
  }

  highlighedSearchText(text: string, query: string) {
    return this.formatService.highlighedSearchText(text, query);
  }

  async handleItemSearch(query: string = '') {
    if (this.serviceItem.type === 'partLookUp') {
      if (query) {
        query = query.toLowerCase();

        this.itemSuggestions = this.partsLookupDropDownList.filter((item) => item.name.toLowerCase().includes(query));
      }
    } else if (['part', 'labor', 'tire', 'bundle', 'hazmatFee'].includes(this.serviceItem.type)) {
      try {
        this.isSearching = true;

        const { records = [] } = await this.httpService.getItems({
          limit: 100,
          type: this.serviceItem.type,
          search: query.trim(),
          activeStatus: this.serviceItem.type === 'bundle' ? true : '',
        });

        if (records.length) {
          this.itemSuggestions = records.map((part: any) => {
            part.itemTitle = [part.title || '', part.code || ''].filter((str) => str).join(' - ');
            part.cost = this.formatService.setDynamicCostAndPrice(part, 'cost');
            part.price = this.formatService.setDynamicCostAndPrice(part, 'price');
            if (this.companyLocalization) {
              part.itemTitleFR = [part.titleFR || '', part.code || ''].filter((str) => str).join(' - ');
              if (part.titleFR && part.titleFR.toLowerCase().includes(query.trim().toLowerCase())) {
                part.searchBy = 'titleFR';
              } else {
                part.searchBy = 'title';
              }
            }
            return part;
          });
        } else {
          this.itemSuggestions = [];
        }
      } catch (err) {
        this.helperService.showToaster('error', err);
      } finally {
        this.isSearching = false;
      }
    } else if (['tireStorage'].includes(this.serviceItem.type) && this.isTireStorage2Enabled) {
      try {
        this.isSearching = true;

        const conf = {
          limit: 1000,
          sortField: 'title',
          sortOrder: 1,
          search: query.trim(),
          activeStatus: true,
        };
        this.httpService.getItems({ ...conf, type: 'tireStorageTemplate' }).then(
          (data: any) => {
            if (data.records) {
              const sortedData = sortBy(data.records, (item: any) => { return item?.title });
              const tireStorageTemplates = sortedData.map((tireStorage: any) => {
                tireStorage.itemTitle = tireStorage.title || '';
                // part.cost = this.formatService.setDynamicCostAndPrice(part, 'cost');
                // part.price = this.formatService.setDynamicCostAndPrice(part, 'price');
                if (this.companyLocalization) {
                  tireStorage.itemTitleFR = tireStorage.titleFR || '';
                  if (tireStorage.titleFR && tireStorage.titleFR.toLowerCase().includes(query.trim().toLowerCase())) {
                    tireStorage.searchBy = 'titleFR';
                  } else {
                    tireStorage.searchBy = 'title';
                  }
                }
                return tireStorage;
              });
              this.itemSuggestions = [...tireStorageTemplates];
            }else{
              this.itemSuggestions = [];
            }
          }
        );
      } catch (err) {
        this.helperService.showToaster('error', err);
      } finally {
        this.isSearching = false;
      }
    }
  }

  handleServiceItemAdd() {
    if (!this.isNewServiceAdded) {
      this.addServiceItem.emit();
      this.isNewServiceAdded = true;
    }
  }

  handleItemTypeSearch(query: string) {
    this.itemTypeSuggestions = [...this.itemTypeOptions.filter(({ highlightField }) => new RegExp(query, 'i').test(highlightField))];
  }

  handleCreateItem(data: any) {
    this.itemDelete.emit(this.index);
    this.dataService.sendData(
      this.dataService.typePassData('open-item-dialog', {
        type: this.serviceItem.type,
        isOpenFromRO: false,
        payload: { openFrom: 'cannedService' },
      }),
    );
  }
}
